module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_01-bc9d6e0756673a3c0a04bad9f521aa6c.png";